module.exports = __webpack_public_path__ + "static/media/explorer.48751042.svg";